<template>
  <!-- ADD Bank -->
  <v-layout row justify-center>
    <v-dialog v-model="editBankModal" persistent max-width="440px">
      <v-card>
        <form action="" @submit.prevent="submitForm()">
          <v-card-title>
            <v-flex xs11 sm11 md11><span class="headline">Update Bank</span></v-flex>
            <v-flex xs1 sm1 md1>
              <v-btn flat @click="closeEditBankModal(), $validator.reset()" class="close"
                >&times;</v-btn
              >
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-alert type="success" :value="checkAlert">
              Bank updated successfully
            </v-alert>
            <v-alert type="error" :value="errorAlert">
              Please update anything
            </v-alert>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm10 md4>
                  <v-text-field
                    label="Bank Name*"
                    v-model="editBankData.bank_name"
                    :error-messages="errors.collect('Bank Name')"
                    v-validate="'required'"
                    data-vv-name="Bank Name"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              style="height:auto"
              @click="closeEditBankModal(), $validator.reset()"
              outline
              color="normal"
              >Cancel</v-btn
            >
            <v-btn type="submit" style="height:auto; margin-right: 3%" outline color="success"
              >Update</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
  <!-- /ADD Bank -->
</template>

<script>
export default {
  props: [
    'editBank',
    'editBankData',
    'editBankModal',
    'checkAlert',
    'errorAlert',
    'closeEditBankModal'
  ],

  methods: {
    submitForm(event) {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.editBank()
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog-dialog--active-dialog--persistent {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}
</style>



// WEBPACK FOOTER //
// src/components/bank/editBank.vue